import { useTranslation } from 'react-i18next'

import Button from '../../Button'
import { getIsCalendarGridDayFull } from '../../CalendarGrid'
import { useCalendarContext } from '../Calendar.hooks'

import { QA_NAME_CALENDAR_RELIEVE_DAY_BUTTON } from './CalendarDayPopoverActions.constants'

function CalendarDayPopoverActions({ day, dayLoad, items, onClose }) {
  const { t } = useTranslation()

  const { onOpenRelieveDay } = useCalendarContext()

  function handleClickRelieveDay() {
    onClose()

    onOpenRelieveDay({ day, dayLoad, items })
  }

  return getIsCalendarGridDayFull(dayLoad) ? (
    <Button.Outlined
      qaName={QA_NAME_CALENDAR_RELIEVE_DAY_BUTTON}
      text={t('Calendar.RelieveDayKey')}
      onClick={handleClickRelieveDay}
    />
  ) : null
}

export default CalendarDayPopoverActions
